module.exports = __webpack_public_path__ + "img/editPage_sucai.4da226ab.svg";